import { createComponent } from '@ycos/fela'
import { getFontStyles } from '../'

const Text = createComponent(
  'text',
  ({ theme }) => {
    const { type, name, color } = theme.custom.text

    return {
      ...getFontStyles(theme.typography, { type, name }),
      color,
      margin: 0,
      direction: 'ltr'
    }
  },
  'p'
)

export default Text
